import { LucideProps, Search } from "lucide-react";
import { clsx } from "clsx";
import styles from "./ui-search-icon.module.css";

const styleSearchIcon = {
  sky: styles.sky,
  default: styles.default,
};

export function UiSearchIcon({
  color = "default",
  ...props
}: { color?: "sky" | "default" } & LucideProps) {
  return (
    <Search
      className={clsx(styles.icon, styleSearchIcon[color])}
      size={40}
      {...props}
    />
  );
}
